var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "document-color" }, [
    _vm.label
      ? _c("label", { staticClass: "document-color__label c-input-label" }, [
          _vm._v(_vm._s(_vm.label)),
        ])
      : _vm._e(),
    _c(
      "div",
      { staticClass: "document-color__body" },
      [
        _c("color-picker", {
          ref: "picker",
          attrs: {
            value: _vm.value,
            validate: _vm.validate,
            "default-color": _vm.defaultColor,
          },
          on: { input: _vm.onInput },
        }),
        _c(
          "div",
          {
            staticClass: "document-color__icon",
            style: {
              color: _vm.value || _vm.defaultColor,
            },
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "10",
                  height: "13",
                  viewBox: "0 0 10 13",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M6.96875 1H1V12H9V3.03125M6.96875 1L9 3.03125M6.96875 1V3.03125H9M3 6C3 6 5.4379 6 7 6M3 9.03125C3 9.03125 5.4379 9.03125 7 9.03125",
                    stroke: "currentColor",
                    "stroke-width": "2",
                  },
                }),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }